import React from "react";
import { GsdReadableBlock } from "../../components/GsdReadableBlock.jsx";
import { GsdPageHeader } from "../../components/GsdPageHeader.jsx";
import { GsdStandaloneModuleSubNav } from "./GsdStandaloneModuleSubNav.jsx";
import { resolveStandaloneModuleLabel } from "./createStandaloneModuleConfig.js";

/**
 * Layout wrapper — module GSD à part avec sous-navigation interne.
 */
export function GsdStandaloneModuleLayout({
  title,
  subtitle,
  icon,
  basePath,
  tabs = [],
  lang = "fr",
  activeTab,
  notice,
  renderTabLink,
  children,
  variant = "default",
  testId = "gsd-standalone-module-layout",
  subNavTestId,
  showHeader = false,
  moduleTestId,
}) {
  const locale = lang === "en" ? "en" : "fr";
  const resolvedTitle = typeof title === "string" ? title : resolveStandaloneModuleLabel(locale, title);
  const resolvedSubtitle =
    typeof subtitle === "string"
      ? subtitle
      : subtitle
        ? resolveStandaloneModuleLabel(locale, subtitle)
        : null;

  return (
    <div
      className={`gsd-standalone-module gsd-standalone-module--${variant}`}
      data-testid={moduleTestId ?? testId}
    >
      {showHeader ? (
        <GsdReadableBlock variant="default">
          <GsdPageHeader
            title={icon ? `${icon} ${resolvedTitle}` : resolvedTitle}
            subtitle={resolvedSubtitle}
            testId={`${testId}-header`}
          />
        </GsdReadableBlock>
      ) : null}

      {notice ? (
        <GsdReadableBlock testId={`${testId}-notice`} variant="default">
          {typeof notice === "string" ? <p className="gsd-standalone-module__notice">{notice}</p> : notice}
        </GsdReadableBlock>
      ) : null}

      <GsdStandaloneModuleSubNav
        basePath={basePath}
        tabs={tabs}
        lang={lang}
        activeTab={activeTab}
        renderTabLink={renderTabLink}
        testId={subNavTestId ?? `${testId}-subnav`}
      />

      <div className="gsd-standalone-module__content" data-testid={`${testId}-content`}>
        {children}
      </div>
    </div>
  );
}
